import positionImg from "@/assets/img/position.png";
import "./index.scss";
import { useClientLayout } from "../../../../hooks";
interface IProps {
  style: React.CSSProperties;
  isPC: boolean;
  markScale: number;
  name: string;
}

const Postion = (props: IProps) => {
  const { isPC, markScale, style, name } = props;
  const { targetRef, width, height } = useClientLayout();

  const { left = 0, top = 0, ...restStyle } = style as any;

  let positionStyle = { ...restStyle, left: `calc(${left} - ${width / 2}px)`, top: `calc(${top} - ${height / 2}px)` };
  if (!isPC) {
    positionStyle = { ...positionStyle, transform: `scale(${markScale * 0.5})` }
  }

  return (
    <div style={positionStyle} ref={targetRef} className="positionWrap">
      <img className="positionImg" src={positionImg} alt="" />
      <div>{name}</div>
    </div>
  )
}

export default Postion;